import VueRouter from 'vue-router';

import Login from '@/components/page/Login';
import Setting from '@/components/page/Setting';
import MemberRegister from '@/components/modal/MemberRegister';
import Empty from '@/components/page/Empty';
import Reservation from '@/components/page/Reservation';
import Guide from '@/components/page/Guide';
import ContractEditor from '@/components/page/ContractEditor';
import Home from '@/components/page/Home';
import Attendance from '@/components/page/Attendance';
import MyPage from '@/components/page/MyPage';
import PageNotFound from '@/components/page/PageNotFound';
import PageFrame from '@/components/PageFrame';
import WagesAgreementContents from '@/components/common/WagesAgreementContents'
import ContractAgreementContents from '@/components/common/ContractAgreementContents'

const router = new VueRouter({
    mode: 'history',
    routes: [
        {path : '/register', component : MemberRegister},
        {path : '/view/login', component : Login},
        {path : '/contract_editor', component : ContractEditor},
        {
            path : '/view',
            component : PageFrame,
            children : [
                {path : 'reservation', component : Reservation},
                {path : 'wages_agreement_contents', component : WagesAgreementContents},
                {path : 'contract_agreement_contents', component : ContractAgreementContents},
                {path : 'attendance', component : Attendance},
                {path : 'my_page', component : MyPage},
                {path : 'agreement_wage_pop', component : Empty},
                {path : 'agreement_work_pop', component : Empty},
                {path : 'home', component : Home},
                {path : 'setting', component : Setting},
                {path : 'guide', component : Guide},
            ]
        },

        {path: "*", component: PageNotFound }
    ]
});

//페이지화면에서 로그인, 혹은 권한 체크시
router.beforeEach((to, from,next) => {
    if (to.matched.some(route => route.meta.requiresAuth)) {
        // if(!GlobalStore.isLogin()){
        //     GlobalStore.checkLoginAndConfirm(() => {
        //         next()
        //     });
        //     return;
        // }
        // if(localStorage['loginInfo'] != null){

            // if(to.matched.some(route => route.meta.requiresCenter)) {
            //     if (!window.Vue.$cookies.get('center_token')) {
            //         store.commit('showAlert', '센터 지정 후 사용가능합니다.');
            //         if(from.path != '/emptycenter') router.push({ path: '/emptycenter' });
            //         return;
            //     }
            // }
            //
            // next();
        // } else {
        //     next('/login');
        // }
    }
    next();
});

export default router;
